import React, {
  useState,
  useEffect,
} from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';
import moment from 'moment';
import Input from '@material-ui/core/Input';
import Send from '@material-ui/icons/Send';
import CancelIcon from '@material-ui/icons/Cancel';
import Request from '~/providers/Request';
import GridContainer from '~/components/GridContainer';
import GridItem from '~/components/GridItem';
import InputControl from '~/components/Input/InputControl';
import InputDate from '~/components/Input/InputDate';
import Button from '~/components/Button';
import Dialog from '~/components/Dialog';
import PushRecord from '~/records/PushRecord';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import { appName } from '../../../../config/uri';

const attrName = (attr) => PushRecord.hummanAttributeName(attr);

const initialRecord = () => ({
  imageId: null,
  title: `Doctor ${appName} 👨‍⚕️`,
  message: 'Clique aqui e converse com o doutor.',
  title_en: `${appName} Doctor 👨‍⚕️`,
  message_en: 'Click here and talk to the doctor.',
  title_es: `${appName} Doctor 👨‍⚕️`,
  message_es: 'Haga clic aquí y hable con el médico.',
  link_url: 'whereby.com/geolifemedico2',
  send_at: moment().format(),
});

function MedicPushModal(props) {
  const { open, onClose, name, id, doctor_schedule } = props;
  const { t } = useTranslation();
  const [record, setRecord] = useState(new PushRecord(initialRecord(doctor_schedule)));
  const [language, setLanguage] = useState('pt');
  const languageObject = {
    pt: '',
    en: '_en',
    es: '_es',
  };

  useEffect(() => {
    handleChange(initialRecord(doctor_schedule));
    setLanguage('pt');
  }, [open]);

  const handleChange = (attrs) => {
    setRecord(record.updateAttributes(attrs));
  };

  async function submitNotification() {
    const data = record.toParams();
    Request.post(`/admin/users/${id}/send_push_medic`, data, {}, { controller: 'users' })
      .then(() => {
        toast.success(t('person.toast.push_success'));
        onClose();
      })
      .catch(e => {
        toast.error('person.toast.push_fail');
        onClose();
        console.error(e);
      });
  }

  const handleRadio = event => setLanguage(event.target.value);

  return (
    <Dialog
      // maxWidth='md'
      icon={<Send />}
      isOpen={open}
      handleClose={onClose}
      title={t('sendNotificationTo', { name })}
      dialogActions={
        <React.Fragment>
          <Button variant='text' color='error' onClick={onClose}>
            <CancelIcon />&nbsp;{t('Cancel')}
          </Button>
          <Button variant="text" color='success' onClick={submitNotification}>
            <Send />&nbsp;{t('Send')}
          </Button>
        </React.Fragment>
      }
    >
      <GridContainer>
        <GridItem xs={12} md={12}>
          <RadioGroup aria-label="position" name="position" value={language} onChange={handleRadio} row>
            <FormControlLabel
              value="pt"
              control={<Radio color="primary" />}
              label="PT-BR"
              labelPlacement="end"
            />
            <FormControlLabel
              value="en"
              control={<Radio color="primary" />}
              label="EN"
              labelPlacement="end"
            />
            <FormControlLabel
              value="es"
              control={<Radio color="primary" />}
              label="ES"
              labelPlacement="end"
            />
          </RadioGroup>
        </GridItem>
        <GridItem xs={8} md={6}>
          <InputControl
            name={`title${languageObject[language]}`}
            value={record.get(`title${languageObject[language]}`)}
            label={attrName(`title${languageObject[language]}`)}
            required={true}
            inputComponent={Input}
            onChange={handleChange}
          />
        </GridItem>
        <GridItem xs={8} sm={10} md={6}>
          <InputControl
            value={moment(record.get('send_at')).format()}
            name="send_at"
            label={attrName('send_at')}
            required={true}
            inputComponent={InputDate}
            InputProps={{
              type: 'datetime',
              minDate: moment(),
            }}
            onChange={(date) => setRecord(record.updateAttributes({ send_at: moment(date).format() }))}
          />
        </GridItem>
        <GridItem xs={12} sm={12}>
          <InputControl
            value={record.get(`message${languageObject[language]}`)}
            name={`message${languageObject[language]}`}
            label={attrName(`message${languageObject[language]}`)}
            required={true}
            inputComponent={Input}
            InputProps={{
              multiline: true,
              rows: '4',
            }}
            onChange={handleChange}
          />
        </GridItem>
        <GridItem xs={12} sm={12}>
          <InputControl
            value={record.get('link_url')}
            name="link_url"
            label={attrName('link_url')}
            inputComponent={Input}
            onChange={handleChange}
          />
        </GridItem>
      </GridContainer>
    </Dialog>
  );
}

MedicPushModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  name: PropTypes.string,
  id: PropTypes.string,
  doctor_schedule: PropTypes.bool,
};

export default MedicPushModal;
